// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\BillingPaymentMethodListResponse

import { hydrateBillingPaymentMethod, type BillingPaymentMethod, type BillingPaymentMethodApiResponse } from './billingPaymentMethod.gen';

export type BillingPaymentMethodListApiResponse = {
	items: BillingPaymentMethodApiResponse[];
};

export type BillingPaymentMethodList = {
	items: BillingPaymentMethod[];
};

export function hydrateBillingPaymentMethodList(data: BillingPaymentMethodListApiResponse): BillingPaymentMethodList {
	return {
		...data,
		items: data.items.map(hydrateBillingPaymentMethod),
	};
}